import { render, staticRenderFns } from "./profile-selector-btn.vue?vue&type=template&id=d04e169c&scoped=true&"
import script from "./profile-selector-btn.vue?vue&type=script&lang=js&"
export * from "./profile-selector-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04e169c",
  null
  
)

export default component.exports